<div class="card h-[calc(100vh-200px)] flex flex-col" [@simpleFadeAnimation]="'in'">
  <div class="flex items-center justify-between card-header">
    <h3 class="card-title">Transactions with Pending Alerts</h3>
  </div>
  <div kendoWindowContainer></div>
  <div kendoDialogContainer></div>
  <div class="card-body flex flex-col flex-1 overflow-hidden">
    <!-- Search panel: server-side filters. Same grid alignment as the
         All Transactions "Search Details" panel (label w-32 + 250px control). -->
    <!-- 25px between the filters/legend block and the grid -->
    <div class="shrink-0" style="margin-bottom: 25px">
      <form
        class="grid grid-cols-1 text-black k-form sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 dark:text-white"
        [formGroup]="searchForm"
        (ngSubmit)="onSearch()"
      >
        <div class="flex items-center gap-2">
          <kendo-label class="w-32 text-black dark:text-white" text="Branch:"></kendo-label>
          <kendo-dropdownlist
            [data]="branches"
            [defaultItem]="defaultBranchItem"
            formControlName="branchNumber"
            style="width: 250px"
          ></kendo-dropdownlist>
        </div>
        <div class="flex items-center gap-2">
          <kendo-label class="w-32 text-black dark:text-white" text="Rep:"></kendo-label>
          <kendo-dropdownlist
            [data]="reps"
            textField="fullName"
            valueField="repId"
            [valuePrimitive]="true"
            [defaultItem]="defaultRepItem"
            [filterable]="true"
            formControlName="repId"
            style="width: 250px"
          ></kendo-dropdownlist>
        </div>
        <div class="flex items-center gap-2">
          <kendo-label class="w-32 text-black dark:text-white" text="Status:"></kendo-label>
          <kendo-dropdownlist
            [data]="statuses"
            textField="statusTypeDesc"
            valueField="statusTypeId"
            [valuePrimitive]="true"
            [defaultItem]="defaultStatusItem"
            formControlName="statusTypeId"
            style="width: 250px"
          ></kendo-dropdownlist>
        </div>
        <div class="flex items-center gap-2">
          <kendo-label class="w-32 text-black dark:text-white" text="Received Begin:"></kendo-label>
          <kendo-datepicker
            formControlName="receivedStartDate"
            [format]="'MM/dd/yyyy'"
            style="width: 250px"
          ></kendo-datepicker>
        </div>
        <div class="flex items-center gap-2">
          <kendo-label class="w-32 text-black dark:text-white" text="Received End:"></kendo-label>
          <kendo-datepicker
            formControlName="receivedEndDate"
            [format]="'MM/dd/yyyy'"
            style="width: 250px"
          ></kendo-datepicker>
        </div>
        <div class="flex items-center gap-2">
          <button kendoButton themeColor="primary" type="submit">Search</button>
          <button kendoButton type="button" (click)="clearSearch()">Clear</button>
          <button
            *ngIf="filter.filters.length > 0"
            kendoButton
            themeColor="error"
            fillMode="outline"
            type="button"
            (click)="clearFilters()"
          >
            Clear Grid Filters
          </button>
        </div>
      </form>

      <!-- Icon legend: 10px above and below -->
      <div
        class="flex flex-wrap gap-3 text-sm legend no-margin text-muted"
        style="padding-top: 10px; padding-bottom: 10px"
      >
            <span class="legend-item"
              ><ng-icon name="heroEye" title="Review Summary"></ng-icon> Review Summary</span
            >
            <span class="legend-item"
              ><ng-icon name="heroMagnifyingGlass" title="Account Form Report"></ng-icon> Account Form
              Report</span
            >
            <span class="legend-item"
              ><ng-icon name="heroArchiveBox" title="Account Form Review"></ng-icon> Account Form
              Review</span
            >
            <span class="legend-item"
              ><ng-icon name="heroPencil" title="Edit Transaction"></ng-icon> Edit Transaction</span
            >
            <span class="legend-item"
              ><ng-icon name="heroFolder" title="View Files"></ng-icon> View Files</span
            >
      </div>
    </div>

    <!-- Grid -->
    <div class="card flex-1 overflow-hidden relative" id="pendingAlertGrid">
      <div
        *ngIf="pendingSpinner"
        class="absolute inset-0 flex items-center justify-center z-10 bg-white dark:bg-gray-800 bg-opacity-70 dark:bg-opacity-70"
      >
        <kendo-loader size="large" themeColor="primary" type="converging-spinner"></kendo-loader>
      </div>
      <kendo-grid
        style="height: 100%"
        [data]="view"
        [pageable]="{ buttonCount: 5, info: true, type: 'numeric', pageSizes: [10, 20, 50, 100] }"
        [pageSize]="pageSize"
        [skip]="skip"
        [sortable]="true"
        size="small"
        [sort]="sort"
        [filter]="filter"
        [resizable]="true"
        [filterable]="true"
        [navigable]="true"
        [scrollable]="'scrollable'"
        (sortChange)="sortChange($event)"
        (filterChange)="onFilterChange($event)"
        (pageChange)="onPageChange($event)"
      >
        <!-- Bookmark -->
        <kendo-grid-column field="bookm" title="" [width]="40" [filterable]="false" [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              (click)="updateBookmark(dataItem)"
              [ngClass]="{
                'black-color': !isBookmarked(dataItem),
                'blue-color': isBookmarked(dataItem)
              }"
              class="cursor-pointer"
              [title]="isBookmarked(dataItem) ? 'Remove Bookmark' : 'Add Bookmark'"
            >
              <ng-icon name="heroBookmarkSolid"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="branchNumber" title="Branch Number" [hidden]="true"></kendo-grid-column>
        <kendo-grid-column field="blotterId" title="ID" [width]="70" filter="numeric"></kendo-grid-column>
        <kendo-grid-column field="repName" title="Rep Name">
          <ng-template kendoGridFilterCellTemplate let-filter>
            <gd-dropdown-filter
              [filter]="filter"
              [data]="passingrepfilter"
              [defaultTextString]="'Filter By Rep'"
              textField="repName"
              valueField="repName"
            ></gd-dropdown-filter>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="clientName" title="Client Name"></kendo-grid-column>
        <kendo-grid-column field="accountName" title="Account">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="selectable" title="View/Edit Account" (click)="viewClientInfo(dataItem.clientId)">
              {{ dataItem.accountName }}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="productTypeDesc" title="Product"></kendo-grid-column>
        <kendo-grid-column field="sponsorName" title="Sponsor"></kendo-grid-column>
        <kendo-grid-column field="transactionTypeDesc" title="Trans Type"></kendo-grid-column>
        <kendo-grid-column field="amount" title="Amount" format="{0:c}" [filterable]="false"></kendo-grid-column>
        <kendo-grid-column field="dateReceived" title="Date Received" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.dateReceived | date : 'MM/dd/yyyy' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="statusTypeDesc" title="Status">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container [ngSwitch]="dataItem.statusTypeId">
              <span *ngSwitchCase="-2">Rep Processing Paperwork</span>
              <span *ngSwitchCase="1">Submitted for Review</span>
              <span *ngSwitchCase="2">Pending - incomplete paperwork (notify rep)</span>
              <span *ngSwitchCase="3">Pending - insurance review</span>
              <span *ngSwitchCase="4">Pending - paperwork review complete</span>
              <span *ngSwitchCase="5">Pending - preliminary review complete</span>
              <span *ngSwitchCase="6">Pending - insurance approved, compliance pending</span>
              <span *ngSwitchCase="7">Pending - principal review issue</span>
              <span *ngSwitchCase="8">Insurance Rejection (notify rep)</span>
              <span *ngSwitchCase="9">Compliance Rejection (notify rep)</span>
              <span *ngSwitchCase="10">Approved - incidental incomplete paperwork (notify rep)</span>
              <span *ngSwitchCase="11">Approved</span>
              <span *ngSwitchCase="12">Rejected - case closed</span>
              <span *ngSwitchDefault>{{ dataItem.statusTypeDesc }}</span>
            </ng-container>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="approvedByDate" title="Approval Date" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.approvedByDate | date : 'MM/dd/yyyy' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="enteredByRep" title="Entered By Rep" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.enteredByRep ? 'True' : 'False' }}
          </ng-template>
        </kendo-grid-column>

        <!-- ############# Review Summary ############# -->
        <kendo-grid-column [width]="40" [hidden]="hidebyRole" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              *ngIf="dataItem.showReviewTransaction"
              class="icon-btn"
              title="Review Summary"
              (click)="
                ReviewAccountReviewTransactionsview(
                  dataItem.blotterId,
                  dataItem.clientId,
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.statusTypeId,
                  dataItem.transactionTypeId,
                  dataItem.productTypeId,
                  dataItem.showReviewTransaction,
                  dataItem.showAccountReview,
                  dataItem.state,
                  dataItem.repCodeId
                )
              "
            >
              <ng-icon name="heroEye" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <!-- ############# Account Form Report ############# -->
        <kendo-grid-column [width]="40" [hidden]="hidebyRole" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              *ngIf="
                dataItem.accountFormReviewCount > 0 &&
                dataItem.statusTypeId > -2 &&
                dataItem.newAccountForm === 'On File' &&
                dataItem.blotterId > 0
              "
              class="icon-btn"
              title="Account Form Receipt"
              (click)="openForm(dataItem)"
            >
              <ng-icon name="heroMagnifyingGlass" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <!-- ############# Account Form Review ############# -->
        <kendo-grid-column [width]="40" [hidden]="hidebyRole" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              *ngIf="dataItem.showAccountReview"
              class="icon-btn"
              title="Account Form Review"
              (click)="
                reviewAccountTransactionsView(
                  dataItem.blotterId,
                  dataItem.clientId,
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.statusTypeId,
                  dataItem.transactionTypeId,
                  dataItem.productTypeId,
                  dataItem.showReviewTransaction,
                  dataItem.showAccountReview,
                  dataItem.state,
                  dataItem.repCodeId
                )
              "
            >
              <ng-icon name="heroArchiveBox" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <!-- ############# Edit Transaction ############# -->
        <kendo-grid-column [width]="40" [hidden]="hidebyRole" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              class="icon-btn"
              title="Edit Transaction"
              (click)="
                editTransactions(
                  dataItem.blotterId,
                  dataItem.clientId,
                  dataItem.repId,
                  dataItem.clientName,
                  dataItem.statusTypeId,
                  dataItem.transactionTypeId,
                  dataItem.productTypeId,
                  dataItem.showReviewTransaction,
                  dataItem.showAccountReview,
                  dataItem.state,
                  dataItem.repCodeId
                )
              "
            >
              <ng-icon name="heroPencil" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
        <!-- ############# View Files ############# -->
        <kendo-grid-column [width]="40" [sticky]="true" headerClass="no-border" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a
              class="icon-btn"
              title="View Files"
              (click)="
                viewFiles(dataItem.repId, dataItem.clientName, dataItem.blotterId, dataItem.clientId, 'blotterId')
              "
            >
              <ng-icon name="heroFolder" class="xl"></ng-icon>
            </a>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>

  <!-- Account Form Receipt -->
  <kendo-dialog *ngIf="openAccountReadOnly" (close)="onDialogReciptClose()" [minWidth]="250" [width]="550">
    <kendo-dialog-titlebar>
      <div class="text-lg font-medium flex items-center gap-2">
        <span class="k-icon k-i-print"></span> Print Receipt
      </div>
    </kendo-dialog-titlebar>
    <gd-pdfsavior [RepNamInfo]="RepNamInfo" [blotterId]="blotterId"></gd-pdfsavior>
    <kendo-dialog-actions>
      <button kendoButton (click)="onDialogReciptClose()">Close Window</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
